namespace advisorop.components.advisor {

    interface IAdvisorAppController {
    }

    class AdvisorAppController implements IAdvisorAppController {

        constructor() {
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
        }
    }



    class AdvisorApp implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
            };
            this.controller = AdvisorAppController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/advisor-app.html';

            this.$routeConfig = [
                // dashboard 
                { path: "/dashboard", component: "advisorDashboard", name: "Dashboard" }, //Main AUM Dashboard
                { path: "/advisorclients", component: "advisorClients", name: "AdvisorClients" }, //Households/Investors AUM charts...
                { path: "/advisorhouseholddashboard/:householdId", component: "advisorHouseholdDashboard", name: "AdvisorHouseholdDashboard" },//Households dashboard
                { path: "/advisorrtgdashboard/:rtgId", component: "advisorRtgDashboard", name: "AdvisorRtgDashboard" },//RTG dashboard
                { path: "/advisoradgdashboard/:groupId", component: "advisorAdgDashboard", name: "AdvisorAdgDashboard" },//ADG dashboard
                { path: "/advisorinvestordashboard/:investorId", component: "advisorInvestorDashboard", name: "AdvisorInvestorDashboard" },//Investor dashboard
                { path: "/advisoraccounts", component: "advisorAccounts", name: "AdvisorAccounts" }, //active accounts
                { path: "/advisoraccounts/:accountStatus", component: "advisorAccounts", name: "AdvisorAccounts" }, //in progress accounts
                { path: "/advisorproposals", component: "advisorProposals", name: "AdvisorProposals" }, //proposals
                { path: "/accountgrouping", component: "accountGrouping", name: "AccountGrouping" }, //account maintenance
                { path: "/createaccountgroup/:householdId", component: "accountGrouping", name: "CreateAccountGroup" }, 

                // general routes
                { path: "/userprofile", component: "userProfile", name: "UserProfile" },
                // individual routes
                { path: "/createinvestor", component: "investorCrud", name: "CreateInvestor" },
                { path: "/investordetails/:id", component: "investorDetails", name: "InvestorDetails" },
                // rtq routes
                { path: "/newrtq/:investorId", component: "rtq", name: "NewRTQ" },
                { path: "/updatertq/:investorId/:rtqId", component: "rtq", name: "UpdateRTQ" },
                { path: "/newexpresstrack/:investorId/:rtqType", component: "rtq", name: "NewExpressTrack" },
                { path: "/newrtq", component: "rtq", name: "NewRTQBlank" },
                
                // account routes
                //{ path: "/newaccount", component: "newAccountWiz", name: "NewAccount" },
                { path: "/newnewaccount", component: "newNewAccountWiz", name: "NewNewAccount" },
                //{ path: "/updateaccount/:accountId", component: "newAccountWiz", name: "UpdateAccount" }, 
                { path: "/newupdateaccount/:accountId", component: "newNewAccountWiz", name: "NewUpdateAccount" }, 
                { path: "/apptracker/:filterByAdvisor/:includeProposedAmount", component: "appTrackerAdvisor", name: "AppTrackerAdvisor" },
                { path: "/accountpivotgrid", component: "accountPivotGrid", name: "AccountPivotGrid" },

                // monitors routes
                { path: "/monitors/:show", component: "advisorMonitors", name: "Monitors" },

                // householdId should be 0 if we wish from user to select HH
                { path: "/hhreallocation", component: "hhReallocation", name: "HhReallocation" },
                { path: "/hhreallocation/:householdId", component: "hhReallocation", name: "HhReallocation" },

                // mapping account routes
                { path: "/accountmaintenance", component: "accountMaintenance", name: "AccountMaintenance" }, //account maintenance
                { path: "/accountmapping/:accountId", component: "accountMapping", name: "AccountMapping" },

                { path: "/accountsummary/:accountId", component: "accountSummary", name: "AccountSummary" },
                //{ path: "/accountsummary/:accountId/:NP", component: "accountSummary", name: "AccountSummary" },

                { path: "/assignaccountrtg/:accountId", component: "assignRtgForm", name: "AssignAccountRTG" },
                { path: "/assignhousehold/:accountId", component: "assignAccountHouseholdForm", name: "AssignHousehold" },
                
                // households 
                { path: "/createhousehold", component: "householdForm", name: "CreateHousehold" },
                { path: "/updatehousehold/:householdId", component: "householdForm", name: "UpdateHousehold" },
                { path: "/householddetails/:householdId", component: "householdForm", name: "HouseholdDetails" },
                // alerts & notes
                { path: "/alertdashboard", component: "alertDashboard", name: "AlertDashboard" },
                { path: "/alertdashboard/usertaskentry/:showUserentry", component: "alertDashboard", name: "ServiceRequests" },
                { path: "/alertdashboard/workflowtasksalerts/:showWfTask", component: "alertDashboard", name: "WorkflowTasksAlerts" },
                { path: "/alertdashboard/riskmonitoralerts/:showRsikMonitorAlerts", component: "alertDashboard", name: "RiskMonitorAlerts" },
                { path: "/createupdatenote", component: "cuNotes", name: "CuNotes" },
                { path: "/alerttask", component: "alertCuWrapper", name: "AlertCuWrapper" },


                { path: "/createupdateinvestor/:investorId", component: "investorCrud", name: "UpdateInvestor" },


                { path: "/repfeegroup", component: "repFeeGroupWrapper", name: "RepFeeGroupWrapper" },                   
                { path: "/repgroup", component: "repGroupWrapper", name: "RepGroupWrapper" },

                { path: "/updateadvisor/:advisorId", component: "advisorCrudWrapper", name: "AdvisorCrud" },
                { path: "/createadvisor", component: "advisorCrudWrapper", name: "AdvisorCrudWrapper" },
                { path: "/advisorlist", component: "advisorListWrapper", name: "AdvisorListWrapper" },
                //{ path: "/updateadvisor", component: "cuAdvisor", name: "CuAdvisor" },
                { path: "/administrationadvisors", component: "administrationAdvisorWrapper", name: "AdministrationAdvisorWrapper" },
                { path: "/externalsystems", component: "advisorExternalSystem", name: "AdvisorExternalSystem" },
                { path: "/externalsystemwizard/:extSystemId", component: "advisorExternalSystemWizard", name: "AdvisorExternalSystemWizard" },

                
                { path: "/setup", component: "adminPanel", name: "AdminPanel" }, //Setup , Admin panel

                // risk monitor
                { path: "/riskmonitor", component: "riskMonitorDashboard", name: "RiskMonitor" },

                //investment reports
                { path: "/investmentreports/:id/:ppLevel/:tabId", component: "investmentReports", name: "InvestmentReports" },

                // memo account route 
                { path: "/memoaccountdashboard", component: "memoAccount", name: "MemoAccount" },
                { path: "/advisormsgraphintegrationrequest", component: "advisorMsgraphIntegrationRequest", name: "AdvisorMsgraphIntegrationRequest" },
                //{ path: "/advisormsgraphintegrationresponse/:code", component: "advisorMsgraphIntegrationResponse", name: "AdvisorMsgraphIntegrationResponse" },
                { path: "/advisormsgraphintegrationresponse", component: "advisorMsgraphIntegrationResponse", name: "AdvisorMsgraphIntegrationResponse" },

                { path: "/**", redirectTo: ["Dashboard"] },


            ];
        }
    }
    angular.module(Constants.APP).component("advisorApp", new AdvisorApp());


}